import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course04 from "../../../course/course-04/course";
import lesson0402 from "../../../lesson/course-04/lesson-02/lesson";
import lesson0403 from "../../../lesson/course-04/lesson-03/lesson";
import lesson0409 from "../../../lesson/course-04/lesson-09/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "9f4eb409-af06-492e-9609-62335555f50d",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0402),
    lesson: lesson0402,
  },
  {
    id: "ced4eec6-dc6f-4fe0-9421-a3744fa3389d",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0403),
    lesson: lesson0403,
  },
  {
    id: "c2c729f2-f0b0-4940-91c1-dc58aa8a3e7e",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0409),
    lesson: lesson0409,
  },
];

export default lessonLinks;
